import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import BoLoader from "../../helpers/BoLoader";
import NegativeBalanceGrid from "./NegativeBalanceGrid";

const NegativeBalance = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [refereshdata, setRefereshdata] = useState(false);

  //Loader
  const [boloader, setBoLoader] = useState(false);

  useEffect(() => {
    setRefereshdata(true);
  }, []);

  return (
    <div className="col-xl-9 col-lg-12 bo-main-content">
      <div className="row ">
        <BoLoader loading={boloader} />
        <div className="col-sm-6">
          <h3>Negative Transaction(s)</h3>
        </div>
      </div>

      <div>
        {refereshdata && (
          <div>
            <NegativeBalanceGrid
              methodname="changepin"
              placeholdervalue="Search"
              headersdata={[
                "CLIENT NAME",
                "TOKEN ID",
                "CARD HOLDER",
                "Balance",
                "CREATED DATE",
              ]}
              screenname="changepin"
              refereshpage={setRefereshdata}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NegativeBalance;
